/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
import React, { Component } from "react";
import { connect } from "react-redux";
import { I18n } from "react-redux-i18n";
import Request from "shared/Request";
import Button from "@alboompro/boom-components/general/button";
import notification from "@alboompro/boom-components/feedback/notification";
import Skeleton from "@alboompro/boom-components/feedback/skeleton";
import Loader from "shared/components/Loader";

import {
  Container,
  List,
  ListContent,
  ListItem,
  VersionDetails,
  ConfigMenuItem,
  Content,
  Header,
  Display,
  Title
} from "./styles"

class HistoryModalContent extends Component {
  state = {
    versions: [],
    currentVersion: {},
    src: {},
    loading: true,
    loadingVersions: false,
    currentIsSelected: true,
  };

  componentWillMount() {
    const { page: { page_content, domain, slug, id } } = this.props;
    this.setState({ currentVersion: page_content })

    Request.get(`custom-page/page_contents/${id}/versions`)
      .then(({ data }) => {
        const orderedVersions = data.page_contents.sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });
        orderedVersions.splice(orderedVersions.map(item => item._id).indexOf(page_content._id), 1);

        this.setState({ versions: orderedVersions, loadingVersions: true });
      })
      .catch((err) => {
        console.error(err);
      });

    if (process.env.NODE_ENV === "development") {
      import("axios").then(axios => {
        axios
          .get(`${domain}${slug}/?id=${page_content._id}&dev_url=${window.location.origin}`, {
            responseType: "blob"
          })
          .then(response => {
            this.setState({ src: URL.createObjectURL(response.data), loading: false });
          })
          .catch(err => {
            console.log(err)
          });
      });
    } else {
      this.setState({ src: `${domain}${slug}/?id=${page_content._id}`, loading: false });
    }
  }

  setCurrentVersion = version => {
    const { page: { domain, slug, page_content: { _id } } } = this.props;
    this.setState({ loading: true, currentVersion: version, currentIsSelected: version._id === _id })

    if (process.env.NODE_ENV === "development") {
      import("axios").then(axios => {
        axios
          .get(`${domain}${slug}/?id=${version._id}&dev_url=${window.location.origin}`, {
            responseType: "blob"
          })
          .then(response => {
            this.setState({ src: URL.createObjectURL(response.data), loading: false });
          })
          .catch(err => {
            console.log(err)
          });
      });
    } else {
      this.setState({ src: `${domain}${slug}/?id=${version._id}`, loading: false });
    }
  };

  restoreVersion = () => {
    const { currentVersion: { page_id, _id } } = this.state;
    Request.patch(`custom-page/page_contents/${page_id}/${_id}/restore`)
      .then(() => {
        window.location.reload()
      })
      .catch((err) => {
        notification.error({
          target: "#history-modal",
          wrapperStyle: "position: absolute; z-index: 10000; top: 15px; right: 15px;",
          icon: null,
          message: I18n.t("historyModal.error")
        });
      });
  };

  render() {
    const { Line } = Skeleton;

    const { versions, currentVersion, src, loading, loadingVersions, currentIsSelected } = this.state;
    const { page: { page_content }, locale } = this.props;

    const month = new Intl.DateTimeFormat(locale, { month: 'long' } );
    const year = new Intl.DateTimeFormat(locale, { year: 'numeric' } );
    const formatter = new Intl.DateTimeFormat(locale, {
      month: 'long',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });

    const SkeletonTemplate = (
      <div className="skeletonTemplate">
        <div className="skeletonToday">
          <Line width="116px" height={16} />
        </div>
        <div className="skeletonMonth">
          <Line width="50px" height={12} />
          <Line width="24px" height={12} />
        </div>
        <div className="skeletonDate">
          <Line height={16} />
        </div>
        <div className="skeletonDate">
          <Line height={16} />
        </div>
        <div className="skeletonDate">
          <Line height={16} />
        </div>
        <div className="skeletonDate">
          <Line height={16} />
        </div>
        <div className="skeletonMonth">
          <Line width="80px" height={12} />
          <Line width="24px" height={12} />
        </div>
        <div className="skeletonDate">
          <Line height={16} />
        </div>
        <div className="skeletonDate">
          <Line height={16} />
        </div>
        <div className="skeletonDate">
          <Line height={16} />
        </div>
      </div>
    );

    return (
      <Container>
        <List>
          <Skeleton ready={loadingVersions} template={SkeletonTemplate}>
            <ListContent>
              <ListItem>
                <ConfigMenuItem
                  menuItemActive={
                    currentVersion.created_at === page_content.created_at
                  }
                  onClick={() => this.setCurrentVersion(page_content)}
                >
                  <span>
                    {I18n.t("historyModal.today")}
                    <span className="currentVersion">
                      {" "}
                      ({I18n.t("historyModal.currentVersion")})
                    </span>
                  </span>
                </ConfigMenuItem>
              </ListItem>
              {versions.map((item, index) => {
                const createdAt = new Date(item.created_at);
                const lastMonth = month.format(
                  new Date(
                    index === 0
                      ? page_content.created_at
                      : versions[index - 1].created_at
                  )
                );
                return (
                  <>
                    {(index === 0 || month.format(createdAt) !== lastMonth) && (
                      <VersionDetails>
                        <div className="month">{month.format(createdAt)}</div>
                        <div className="year">{year.format(createdAt)}</div>
                      </VersionDetails>
                    )}
                    <ListItem>
                      <ConfigMenuItem
                        menuItemActive={
                          currentVersion.created_at === item.created_at
                        }
                        onClick={() => this.setCurrentVersion(item)}
                      >
                        {formatter.format(createdAt)}
                      </ConfigMenuItem>
                    </ListItem>
                  </>
                );
              })}
            </ListContent>
          </Skeleton>
        </List>
        <Content id="history-modal">
          <Header>
            <Title>{I18n.t("historyModal.contentTitle")}</Title>
            <Button
              style={{ backgroundColor: "#44ADF8", height: "32px" }}
              textStyle={{ color: "#ffffff" }}
              onClick={() => this.restoreVersion()}
              disabled={currentIsSelected || loading}
            >
              {I18n.t("historyModal.restoreButton")}
            </Button>
          </Header>
          <Display>
            {loading ? <Loader /> : <iframe title="History" src={src} />}
          </Display>
        </Content>
      </Container>
    );
  }
}

const mapDispatchToProps = {};

const mapStateToProps = (state) => {
  return {
    locale: state.i18n.locale,
    page: state.page,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HistoryModalContent);